/**
 * Import React libraries.
 */
import * as React from 'react';
import { Size } from '../types';

/**
 * Import custom styles.
 */
import { BREAKPOINTS, ComponentXXS, ComponentXS } from '../styles';

// Add component-specific types
type LabelProps = {
  size?: Size.Small | Size.Medium;
  children?: any;
};

const ReponsiveComponentWrapper: React.FunctionComponent<LabelProps> = ({ children, size }: LabelProps) => {
  // Globally used variables within the component
  const [isMediumView, setIsMediumView] = React.useState<boolean>(false);

  React.useEffect(() => {
    const handleResize = () => {
      const mql = window.matchMedia(`${BREAKPOINTS.MEDIUM.replace('@media ', '')}`);
      setIsMediumView(mql.matches);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size && size === Size.Medium ? (
    <ComponentXS>{children}</ComponentXS>
  ) : size && size === Size.Small ? (
    <ComponentXXS>{children}</ComponentXXS>
  ) : isMediumView ? (
    <ComponentXS>{children}</ComponentXS>
  ) : (
    <ComponentXXS>{children}</ComponentXXS>
  );
};

export default ReponsiveComponentWrapper;
